import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    verifCertifInit: [null],
    verifCertifRequest: ['response'],
    verifCertifSuccess: ['response'],
    verifCertifFailure: ['error'],
})

export const verifCertifTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const verifCertifInit = state => state.merge(INITIAL_STATE)

const verifCertifRequest = state =>
    state.merge({ response: null, loading: true })

const verifCertifSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })

const verifCertifFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        error: true,
        response,
        loading: false,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.VERIF_CERTIF_INIT]: verifCertifInit,
    [Types.VERIF_CERTIF_REQUEST]: verifCertifRequest,
    [Types.VERIF_CERTIF_SUCCESS]: verifCertifSuccess,
    [Types.VERIF_CERTIF_FAILURE]: verifCertifFailure,
})
